import React from 'react';
import PropTypes from 'prop-types';
import { PropTypes as MobxPropTypes } from 'mobx-react';

import styles from './Filters.css';

const IProductType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});

const IPropTypes = {
  className: PropTypes.string,
  /* eslint-disable-next-line react/no-unused-prop-types */
  onTypeSelect: PropTypes.func,
  productTypes: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(IProductType),
    PropTypes.arrayOf(IProductType),
  ]).isRequired,
  selectedTypeId: PropTypes.string,
};

const defaultProps = {
  className: '',
  onTypeSelect: () => {},
  selectedTypeId: null,
};

const Filters = (props) => {
  const filterData = props.productTypes.slice();
  filterData.unshift({
    name: 'Todos',
    id: null,
  });
  return (
    <div className={[props.className, styles.container].join(' ')}>
      {
        filterData.map(data => (
          <button
            className={[styles.filterCard, data.id === props.selectedTypeId ? styles.selected : ''].join(' ')}
            key={data.id}
            onClick={() => props.onTypeSelect(data.id)}
          >
            {data.name}
          </button>
        ))
      }
    </div>
  );
};

Filters.propTypes = IPropTypes;
Filters.defaultProps = defaultProps;

export { Filters };



// WEBPACK FOOTER //
// ./src/pages/product-index/filters/Filters.jsx